// eslint-disable-next-line import/prefer-default-export
export const getUniqueId = (): string => Math.random().toString(36);
